import * as React from 'react';
import { UserMenu } from '@brightlayer-ui/react-components';
import { Avatar } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { ExitToApp } from '@mui/icons-material';
import { useDispatch, useSelector } from 'react-redux';
import { useAuthHelper, useAuthState, getUserId } from '../AuthContextProvider';
import { useHistory } from 'react-router-dom';
import { Thunks } from '../../actions';
import { Selectors } from '../../selectors';
import * as PXBColors from '@brightlayer-ui/colors';

const useStyles = makeStyles(() => ({
    avatarColor: {
        color: PXBColors.white[500],
        backgroundColor: PXBColors.blue[500],
    },
    floatR: {
        float: 'right',
    },
}));
export const OnlyLogout: React.FC = () => {
    const dispatch = useDispatch();
    const classes = useStyles();
    const authHelper = useAuthHelper();
    const history = useHistory();
    const authState = useAuthState();
    const userId = getUserId(authState);

    const email = useSelector(Selectors.User.email);
    const name = useSelector(Selectors.User.name);
    const initials = useSelector(Selectors.User.initials);
    const logoutSession = React.useCallback(() => {
        dispatch(Thunks.Authentication.logout(userId, history, authHelper.onUserNotAuthenticated));
    }, [dispatch, history, userId, authHelper.onUserNotAuthenticated]);

    return (
        <div data-testid="user-menu" className={classes.floatR}>
            <UserMenu
                MenuProps={{
                    anchorOrigin: { horizontal: 'left', vertical: 'top' },
                    transformOrigin: { horizontal: 'right', vertical: 'top' },
                }}
                avatar={<Avatar className={classes.avatarColor}>{initials}</Avatar>}
                menuTitle={name}
                menuSubtitle={email}
                menuGroups={[
                    {
                        items: [
                            {
                                itemID: 'Log Out',
                                title: 'Log Out',
                                icon: <ExitToApp />,
                                onClick: (): void => {
                                    logoutSession();
                                },
                            },

                        ],
                    }
                ]}
            />
        </div>
    );
};
